import { StateCreator } from 'zustand'
import { CampaignCreationState } from '../state'
import { LocationType } from '../../step4/regions-selector/ui/RegionsSelector'

export interface Step4Slice {
    gender: string
    schedule: string
    locations: LocationType[]
    setGender: (gender: string) => void
    setSchedule: (schedule: string) => void
    setLocations: (locations: LocationType[]) => void
    addLocation: (location: LocationType) => void
    removeLocation: (locationId: string) => void
}

export const createStep4Slice: StateCreator<
    CampaignCreationState,
    [],
    [],
    Step4Slice
> = (set) => ({
    gender: '',
    schedule: '',
    locations: [],
    setGender: (gender: string) => set({ gender }),
    setSchedule: (schedule: string) => set({ schedule }),
    setLocations: (locations: LocationType[]) => set({ locations }),
    addLocation: (location: LocationType) =>
        set((state) => ({
            locations: [...state.locations, location],
        })),
    removeLocation: (locationId: string) =>
        set((state) => ({
            locations: state.locations.filter(
                (location) => location.id !== locationId
            ),
        })),
})
